import posthog from "posthog-js";
import { getUserInfo } from "../api/axios";

function baseProps(extra = {}) {
  const userId = getUserInfo()?.selfUserId ?? null;
  const company = (() => {
    try {
      const raw = typeof window !== "undefined" && window.localStorage.getItem("selectedCompany");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();

  return {
    userId,
    companyId: company?.id ?? company?.Id ?? null,
    companyName: company?.name ?? company?.Name ?? null,
    ...extra,
  };
}

export function captureOnboardingEvent(eventName, properties = {}) {
  if (typeof posthog === "undefined" || !posthog.capture) return;
  posthog.capture(eventName, {
    type: "info",
    success: true,
    ...baseProps(properties),
  });
}

export function captureOnboardingException(eventName, reason, properties = {}) {
  if (typeof posthog === "undefined" || !posthog.capture) return;
  posthog.capture(eventName, {
    type: "exception",
    success: false,
    reason: reason ?? "Request failed",
    ...baseProps(properties),
  });
}
